import React from 'react';
import GlobalImage from '../imgComponent/index'
import styles from './index.module.less';

const PageFooter = () => {
  const year = new Date().getFullYear();
  return (
    <div className={`${styles['page-footer']}`}>
        <div className={`${styles['footer-wrap']} flex-row`}>
          <div className={styles.left}>
            <div className={`${styles['group_4']}`}>
              <GlobalImage className={`${styles['label_7']}`} src='logo-new-2x.png' alt="图片" />
            </div>
            <div className={`${styles['group_5']}`}>
              <span className={`${styles['text_14']}`}>
                U校园AI版是外研社Unipus旗下的在线学习平台，为院校外语教学提供混合式教学解决方案。学、练、测、评一站式交互体验，学习内容生动有趣，教学工具科学有效，趣味学习、智慧教学，外语教与学更精彩。U校园AI版，有你更精彩！
              </span>
            </div>
            <div className={`${styles['group_6']} flex-row`}>
              <span className={`${styles['text_17']}`}>
                外语教学与研究出版社有限责任公司&nbsp;版权所有Copyright&nbsp;©&nbsp;1999-{year}FLTRP,All&nbsp;Rights&nbsp;Reserved
              </span>
            </div>
            <div className={`${styles['group_7']} flex-row`}>
              <GlobalImage className={`${styles['thumbnail_2']}`} src='beian-2x.png' alt="图片" />
              <span className={`${styles['text_19']}`}>京公网安备：<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802020838" target="_blank" rel="noreferrer">11010802020838</a>号</span>
              <a className={`${styles['text_20']}`} href="https://beian.miit.gov.cn" target="_blank" rel="noreferrer">京ICP备18030989号-2</a>
            </div>
          </div>
          <div className={styles.right}>
            <div className={`${styles['wrapper_3']} flex-row`}>
              <div className={`${styles['label_10']} ${styles['img_10']}`} />
              <span className={`${styles['text_18']}`}>关注小U，每日坐收专业有趣的外语知识！</span>
              <div className={styles['image-wrapper_11']}>
                <div className={styles['img_18']} />
                <div className={styles['block_2']} />
              </div>
            </div>
            <div className={`${styles['wrapper_3']} flex-row`}>
              <div className={`${styles['label_10']} ${styles['img_10']}`} />
              <span className={`${styles['text_18']}`}>关注U校园AI版教师发展，获取权威专业的教研秘笈！</span>
              <div className={styles['image-wrapper_11']}>
                <div className={styles['img_19']} />
                <div className={styles['block_2']} />
              </div>
            </div>
            <div className={`${styles['wrapper_3']} flex-row`}>
              <GlobalImage className={`${styles['label_10']}`} src='service-2x.png' alt="图片" />
              <span className={`${styles['text_18']}`}>客服邮箱：<a className={styles.email} href="mailto:service@unipus.cn">service&#64;unipus.cn</a></span>
            </div>
            <div className={`${styles['wrapper_3']} flex-row`}>
              <GlobalImage className={`${styles['label_10']}`} src='customer-service-2x.png' alt="图片" />
              <span className={`${styles['text_18']}`}>在线客服：</span>
              <GlobalImage className={`${styles['image_2']}`} src='waiyanshe-service-min.jpeg' alt="图片" />
            </div>
          </div>
        </div>
      </div>
  );
}

export default PageFooter;
